import { Component, Input, OnInit } from '@angular/core';
import { TaskService } from '../../../../services';
import { Message } from '../../../../classes/Message';
import { JobScreenLateStatusTask } from '../../../../interfaces/screen-specific/job-screen';
import { MessageService, SelectItem } from 'primeng';

@Component({
  selector: 'job-screen-late-status',
  templateUrl: './job-screen-late-status.component.html',
  styleUrls: ['./job-screen-late-status.component.scss'],
})
export class JobScreenLateStatusComponent implements OnInit {
  @Input('lateStatusTask') lateStatusTask!: JobScreenLateStatusTask;
  @Input('organisationId') organisationId!: number;
  @Input('organisationTypeId') organisationTypeId!: number;

  private lateStatuses: any[] = [
    { id: 1, title: 'Traffic' },
    { id: 2, title: 'Waiting for Vehicle' },
    { id: 3, title: 'Mobile App/Platform' },
    { id: 4, title: 'Engineius Agreed' },
    { id: 5, title: 'Site Closed' },
    { id: 6, title: 'Incorrect Location' },
    { id: 7, title: 'Vehicle Not On Site' },
    { id: 8, title: 'Breakdown' },
    { id: 9, title: 'Other' },
  ];
  lateStatusesSelectItems: SelectItem[];
  isShownLateStatusesDialog: boolean;
  lateStatusesEdited: any = {};
  awaitingAllocation: boolean;

  constructor(private taskService: TaskService, private messageService: MessageService) {}

  ngOnInit(): void {
    this.initLateStatuses();
  }

  private initLateStatuses() {
    this.lateStatusesSelectItems = [{ value: 0, label: 'On-Time' }];
    this.lateStatuses.forEach((x) =>
      this.lateStatusesSelectItems.push({ label: x.title, value: x.id }),
    );
  }

  getLateStatusTitle(id: number): string {
    let ls = this.lateStatuses.find((o) => o.id == id);
    return ls ? ls.title : null;
  }

  showLateStatusesDialog() {
    this.lateStatusesEdited = {
      taskId: this.lateStatusTask.id,
      pickupLateStatusId: this.lateStatusTask.pickupLateStatusId,
      pickupLateReason: this.lateStatusTask.pickupLateReason,
      dropoffLateStatusId: this.lateStatusTask.dropoffLateStatusId,
      dropoffLateReason: this.lateStatusTask.dropoffLateReason,
    };

    this.isShownLateStatusesDialog = true;
  }

  get lateReasonsValid(): boolean {
    let disable = false;

    if (
      !this.lateStatusesEdited.pickupLateStatusId == true &&
      !this.lateStatusesEdited.dropoffLateStatusId == true
    )
      disable = true;

    if (
      this.lateStatusesEdited.pickupLateStatusId > 0 &&
      !this.lateStatusesEdited.pickupLateReason == true
    )
      disable = true;

    if (
      this.lateStatusesEdited.dropoffLateStatusId > 0 &&
      !this.lateStatusesEdited.dropoffLateReason == true
    )
      disable = true;

    return disable;
  }

  saveLateStatuses() {
    this.taskService
      .saveLateStatuses(this.lateStatusesEdited)
      .then(() => {
        this.lateStatusTask.pickupLateStatusId = this.lateStatusesEdited.pickupLateStatusId;
        this.lateStatusTask.pickupLateReason = this.lateStatusesEdited.pickupLateReason;
        this.lateStatusTask.dropoffLateStatusId = this.lateStatusesEdited.dropoffLateStatusId;
        this.lateStatusTask.dropoffLateReason = this.lateStatusesEdited.dropoffLateReason;

        this.isShownLateStatusesDialog = false;
        this.messageService.add(
          Message.Success('Late statuses successfully changed.', 'Change Late Statuses'),
        );
      })
      .catch((ex) => {
        this.messageService.add(
          Message.Error(
            'An error occurred while changing late statuses. Try again.',
            'Change Late Statuses',
          ),
        );
      });
  }
}
